export const UNLEASH_SESSION_COOKIE = 'unleash-session-id';
export const FEATURE_FLAG_OVERRIDE_COOKIE = 'tkwwffo';

export const FEATURE_FLAG_CREATE_ACCOUNT = 'create-account-entry-point';
